import React from 'react';

const NewsInside = React.lazy(() => import('pages/NewsInside/pages/NewsInsidePage'));
const NewsInsideDetail = React.lazy(() => import('pages/NewsInside/pages/NewsInsideDetail'));

const newsInsideRoutes = [
  {
    path: '/news-inside',
    exact: true,
    name: 'Bản tin',
    component: NewsInside,
    any: true,
  },
  {
    path: '/news-inside/detail/:id',
    exact: true,
    name: 'Chi tiết bản tin',
    component: NewsInsideDetail,
    any: true,
  },
];

export default newsInsideRoutes;
